import { useId, useState } from "react";
import { X } from "lucide-react";
import { Dialog } from "./Dialog";

interface ConfirmDialogProps {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: "default" | "danger";
  /** Se definido, exige digitar esta frase exata para habilitar o confirmar
   * (usado na exclusao de dados do titular — acao irreversivel). */
  requireTypedPhrase?: string;
  busy?: boolean;
  errorMessage?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  tone = "default",
  requireTypedPhrase,
  busy,
  errorMessage,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const titleId = useId();
  const inputId = useId();
  const [digitado, setDigitado] = useState("");

  const bloqueadoPelaFrase =
    Boolean(requireTypedPhrase) && digitado.trim() !== requireTypedPhrase;

  return (
    <Dialog titleId={titleId} onClose={onCancel}>
      <div className="modal__header">
        <h2 id={titleId}>{title}</h2>
        <button
          type="button"
          className="btn btn--ghost btn--icon"
          onClick={onCancel}
          aria-label="Fechar"
        >
          <X className="icon" size={20} aria-hidden="true" />
        </button>
      </div>
      <div className="modal__body">
        <p>{description}</p>
        {requireTypedPhrase && (
          <div className="field">
            <label htmlFor={inputId}>
              Para confirmar, digite <strong>{requireTypedPhrase}</strong>
            </label>
            <input
              id={inputId}
              type="text"
              value={digitado}
              onChange={(e) => setDigitado(e.target.value)}
              autoComplete="off"
            />
          </div>
        )}
        {errorMessage && (
          <p className="field-error" role="alert">
            {errorMessage}
          </p>
        )}
      </div>
      <div className="modal__footer">
        <button type="button" className="btn btn--secondary" onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={tone === "danger" ? "btn btn--danger" : "btn btn--primary"}
          onClick={onConfirm}
          disabled={busy || bloqueadoPelaFrase}
        >
          {busy ? "Aguarde…" : confirmLabel}
        </button>
      </div>
    </Dialog>
  );
}
